import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { flattenStrings } from 'src/shared/lib';
import { personalRangoService } from 'src/app/services/api/personalRango.service';

@Component({
  selector: 'app-data-personal-rango',
  templateUrl: './data-personal-rango.component.html',
  styleUrls: ['./data-personal-rango.component.css'],
})
export class DataPersonalRangoComponent implements OnInit {
  dataInitial: any;
  loading: boolean = true;
  paxHeader: string[] = [];
  paxes: any[] = [];

  currentPage = 1;
  limitPage = 5;
  currentClients: any[] = [];
  HeaderList: string[] = [
    'tipoServicio',
    'categoriaServicio',
    'categoriaProducto',
    'subCategoriaProducto',
    'comentario',
    'destino',
  ];

  location: string | null = null;
  dataFilter: any;
  selectFile: string | null = null;
  arrayFiles: any = [];
  filterValue: any;
  selected: any = null;
  maxPaxColumns: number = 0;
  nroPersonasPaxHeader: any[] = Array.from({ length: this.maxPaxColumns });
  dataSource: any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private personalRangoService: personalRangoService,
    private route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.location = params['location'];
      this.getAllPersonal();
    });
  }

  getLocation(location: string) {
    if (this.location === 'cusco') {
      return 'Cusco';
    } else if (this.location === 'huaraz') {
      return 'Huaraz';
    }
    return '';
  }

  async getAllPersonal() {
    this.loading = true;
    try {
      const observable =
        await this.personalRangoService.useQueryPersonalRango();
      observable.subscribe((response: any) => {
        this.dataInitial = response.data.getAllPersonalRango.filter(
          (item: any) =>
            item.destino?.toLowerCase() === this.location?.toLowerCase()
        );
        console.log(this.dataInitial);

        this.maxPaxColumns = Math.max(
          ...this.dataInitial.map((item: any) => item.nroPersonasPax.length)
        );
        this.nroPersonasPaxHeader = Array.from({ length: this.maxPaxColumns });

        this.paxColumns = Array.from(
          { length: this.maxPaxColumns },
          (_, i) => `pax${i + 1}`
        );

        this.dataSource = new MatTableDataSource(this.dataInitial);
        this.cdr.detectChanges();
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        return response;
      });
    } catch (error) {
      console.error('Error al obtener datos de personal:', error);
      this.loading = false;
    }
  }

  paxColumns: string[] = [];

  applyFilter(event: Event) {
    let dataNew: any = this.dataInitial;
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue && filterValue.trim() !== '') {
      const terms = filterValue
        .toLowerCase()
        .split(' ')
        .filter((t) => t);

      dataNew = dataNew.filter((item: any) => {
        const allValues = flattenStrings(item);
        return terms.every((term) =>
          allValues.some((val) => val.includes(term))
        );
      });
    }
    this.dataSource.data = dataNew;
  }
}
